angular.module('rjmNg.api').factory 'Export', [
  "$resource"
  "phpServiceUrl"
  (
    $resource,
    phpServiceUrl
  ) ->

    (clientId) ->

      actions =
        retry:
          method: 'GET'
          url: phpServiceUrl("/client/#{clientId}/export/:id/retry")

      exportResource = $resource(phpServiceUrl("/client/#{clientId}/export"), {}, actions)

      {
        getAllActive: () ->
          exportResource.query({activeonly: true}).$promise
        retry: (exportId) ->
          exportResource.retry({id: exportId}).$promise
        save: (name, tableId, restrictionSet, columns) ->
          exportResource.save({
            name
            tableId
            restrictionSet
            columns
          }).$promise
      }
]
